<template>
  <div>
    <!-- 预售订单的结算信息 -->
    <div v-if="detailData.presaleOrderInfo">
      <p class="o-title">结算信息</p>
      <div class="o-address o-price">
        <p class="o-address-p">
          <span class="title pre-sell-title">
            <p>定金</p>
            <p v-show="detailData.orderInfo.payStatus == 3 || detailData.orderInfo.payStatus == 6">（已支付）</p>
          </span>
          <span class="text pre-sell-text">
            <p :class="{'red': detailData.orderInfo.payStatus == 1 || detailData.orderInfo.payStatus == 2}">￥{{detailData.presaleOrderInfo.earnestPrice}}
              <!-- <span v-show="detailData.presaleOrderInfo.earnestExpandPrice != detailData.presaleOrderInfo.earnestPrice">（抵扣￥{{detailData.presaleOrderInfo.earnestExpandPrice}}）</span> -->
            </p>
            <p>
              <span v-if="detailData.orderInfo.payStatus == 3 || detailData.orderInfo.payStatus == 6">实付款￥</span>
              <span v-else>应付款￥</span>
              {{detailData.presaleOrderInfo.earnestPrice}}
            </p>
          </span>
        </p>
        <p class="o-address-p">
          <span class="title pre-sell-title">
            <p>尾款</p>
            <p v-show="detailData.orderInfo.payStatus == 3">（已支付）</p>
          </span>
          <span class="text pre-sell-text">
            <p :class="{'red': detailData.presaleOrderInfo.tailTimeStatus == 2 && detailData.presaleOrderInfo.stage == 2}">￥{{detailData.presaleOrderInfo.tailPrice}}</p>
            <p
              v-for="(promotion, index) in detailData.priceInfo.promotionInfo"
              :key="index"
            >{{promotion.promotionName}} - ￥{{promotion.promotionPrice}}</p>
            <p v-show="detailData.priceInfo.couponPrice">优惠券金额 - ￥{{detailData.priceInfo.couponPrice}}</p>
            <p v-show="detailData.orderInfo.payStatus == 3">实付款￥{{detailData.presaleOrderInfo.tailRealPrice}}</p>
          </span>
        </p>
      </div>
    </div>
    <!-- 其它订单的结算信息 -->
    <div v-if="detailData.orderInfo.orderType != 5 && detailData.priceInfo">
      <p class="o-title">结算信息</p>
      <div class="o-item border-top border-bottom">
        <section class="o-item-label">
          <p class="group">商品金额</p>
        </section>
        <section class="o-item-info">
          <p class="group">￥{{detailData.priceInfo.originalPrice}}</p>
        </section>
      </div>
      <template v-if="detailData.priceInfo.promotionInfo.length > 0 || detailData.priceInfo.prepaidCardPrice">
        <div
          class="o-item "
          v-for="(promotion, index) in detailData.priceInfo.promotionInfo"
          :key="index"
        >
          <section class="o-item-label">
            <p class="group promotion-item">{{promotion.promotionName}}</p>
          </section>
          <section class="o-item-info">
            <p class="group promotion-item">-￥{{promotion.promotionPrice}}</p>
          </section>
        </div>
        <!-- 金币 -->
        <div
          class="o-item"
          v-if="detailData.goldInfo && detailData.goldInfo.deduction_price"
        >
          <section class="o-item-label">
            <p class="group">金币</p>
          </section>
          <section
            class="o-item-info"
            v-if="detailData.goldInfo.deduction_price"
          >
            <p class="group">-￥{{detailData.goldInfo.deduction_price}}</p>
          </section>
        </div>
        <!-- 礼品卡 -->
        <div
          class="o-item"
          v-if="detailData.priceInfo.prepaidCardPrice"
        >
          <section class="o-item-label">
            <p class="group">礼品卡</p>
          </section>
          <section
            class="o-item-info"
            v-if="detailData.priceInfo.prepaidCardPrice"
          >
            <p class="group">-￥{{detailData.priceInfo.prepaidCardPrice}}</p>
          </section>
        </div>
        <!-- 优惠明细查看 -->
        <div
          class="o-item o-item-detail"
          v-if="detailData.priceInfo.promotionInfo.length > 0"
        >
          <section class="o-item-label">
            <p class="group"></p>
          </section>
          <section class="o-item-info">
            <!-- <p class="group">点击查看</p> -->
            <p
              class="o-coupon-detail group"
              @click="serachDetail"
              v-if="promotionDetail && promotionDetail.length > 0"
            >优惠明细，查看更多></p>
          </section>
        </div>
      </template>
      <div
        class="o-item border-bottom"
        :class="{
            'border-top': detailData.priceInfo.promotionInfo.length > 0 || detailData.priceInfo.prepaidCardPrice}"
      >
        <section class="o-item-label">
          <p
            class="group"
            v-text="detailData.orderInfo.payStatus != 3 ? '应付款' : '实付款'"
          ></p>
        </section>
        <section class="o-item-info">
          <p
            class="group"
            :class="{'red': detailData.orderInfo.payStatus != 3}"
          >￥{{detailData.priceInfo.realPrice}}</p>
        </section>
      </div>
    </div>
    <!-- 底部操作按钮 -->
    <div class="order-oprate">
      <span v-show="detailData.orderInfo.payStatus == 1 || detailData.orderInfo.payStatus == 2">请在<strong>15</strong>分钟内完成订单支付，否则订单自动取消</span>
      <span>
        <!-- 倒计时和停留在当前页面到结束 -->
        <span
          v-if="detailData.presaleOrderInfo && detailData.presaleOrderInfo.tailTimeStatus == 2 && detailData.presaleOrderInfo.stage==2 && detailData.orderInfo.payStatus!=4&& detailData.orderInfo.payStatus!=5&& detailData.orderInfo.payStatus!=7"
          v-html="timeStr"
        ></span>
        <!-- 支付开始结束时间 -->
        <span v-if="detailData.presaleOrderInfo && detailData.presaleOrderInfo.tailTimeStatus == 1 && detailData.presaleOrderInfo.stage==2 && detailData.orderInfo.payStatus!=4&& detailData.orderInfo.payStatus!=5&& detailData.orderInfo.payStatus!=7">
          支付时间：
          <strong>{{detailData.presaleOrderInfo.tailStartTime.split(' ')[0].replace(/-/g, '.')}} - {{detailData.presaleOrderInfo.tailEndTime.split(' ')[0].replace(/-/g, '.')}}</strong>
        </span>

        <button
          disabled
          class="disabled-operate"
          v-if="detailData.presaleOrderInfo && detailData.presaleOrderInfo.tailTimeStatus==1 && detailData.operateInfo.operateStatus==4"
        >{{detailData.operateInfo.operateText}}</button>
        <span v-else>
          <a
            v-show="detailData.operateInfo.operateHref.length && detailData.operateInfo.operateText != ''"
            class="oprate-btn"
            data-xeslog-params="key=xeslog_web_orderDetail_ocenter&action=goToPay_order"
            :href="detailData.operateInfo.operateHref"
          >{{detailData.operateInfo.operateText}}</a>
        </span>
      </span>
    </div>
    <discount
      :visible.sync="promotionShow"
      :promotionDetail="promotionDetail"
      v-if="promotionDetail && promotionDetail.length > 0"
      :gift="detailData.priceInfo && detailData.priceInfo.prepaidCardPrice || 0"
      :gold="detailData.goldInfo && detailData.goldInfo.deduction_price || 0"
    ></discount>
  </div>
</template>
<script>
import discount from '@/components/sub/Discount.vue'
export default {
  props: ['detailData', 'timeStr'],
  data () {
    return {
      promotionShow: false
    }
  },
  computed: {
    promotionDetail () {
      let details = []
      if (this.detailData.priceInfo.promotionDetail) {
        let { productPromotion, orderPromotion, couponPromotion } = this.detailData.priceInfo.promotionDetail
        details = [productPromotion, orderPromotion, couponPromotion]
        details = details.filter(item => item)
        console.log('details', details)
      }
      // let detail = detailData.priceInfo.promotionDetail || []
      return details
    }
  },
  components: {
    discount
  },
  methods: {
    serachDetail () {
      this.promotionShow = true
    }
  }
}
</script>
<style lang="less">
.o-title {
  font-weight: bolder;
  padding-bottom: 10px;
}
.o-coupon-detail {
  color: #ee3030;
  font-size: 12px;
  cursor: pointer;
  margin: 0 !important;
  padding-top: 8px;
}
.o-address {
  margin-bottom: 20px;
  color: #666;
  .title {
    min-width: 90px;
    display: inline-block;
    padding: 15px 20px;
  }
  .pre-sell-title {
    border-right: none;
    vertical-align: top;
    p + p {
      // margin-top: 10px;
      margin-top: 2px;
    }
  }
  .text {
    display: inline-block;
    padding: 15px 20px;
    color: #333333;
    max-width: 820px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: bottom;
    border-left: 1px solid #e0e0e0;
  }
  .pre-sell-text {
    border-right: none;
    border-left: solid 1px #e0e0e0;
    p {
      color: #666;
      font-size: 12px;
      padding: 0;
      & + p {
        margin-top: 9px;
      }
    }
  }
  .oprate {
    cursor: pointer;
    color: #f13232;
  }
  .border-bottom {
    border-bottom: solid 1px #e0e0e0;
  }
}
.o-address {
  .o-address-p {
    border: solid 1px #e0e0e0;
    font-size: 12px;
    line-height: 14px;
    &:not(:first-child) {
      border-top: none;
    }
    .title {
      text-align: right;
    }
    .title-motion {
      margin-bottom: 10px;
      display: block;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .red {
      color: #ff0021;
    }
    .price {
      display: inline-block;
      vertical-align: top;
      border-left: 1px solid #e0e0e0;
      padding: 15px 20px;
      p {
        margin-top: 9px;
      }
    }
  }
  .no-border-top {
    border-top: none;
  }
  .o-promotion {
    border-bottom: solid 1px #e0e0e0;
    .o-address-p {
      border-bottom: none;
      border-top: none;
      .text,
      .title {
        padding-top: 6px;
        padding-bottom: 6px;
      }
    }
  }
}
.o-price {
  .o-address-p {
    .title {
      // min-width: 101px;
      width: 101px;
      text-align: center;
      // border-right: 1px solid #e0e0e0;
    }
  }
}
.order-oprate {
  text-align: right;
  padding: 10px 0;
  .oprate-btn {
    padding: 6px 20px;
    border: none;
    font-size: 14px;
    border-radius: 2px;
    background: #f13232;
    color: #ffffff;
    cursor: pointer;
    margin-left: 16px;
    width: 90px;
    display: inline-block;
    font-size: 12px;
    height: 32px;
    line-height: 20px;
    &:hover {
      background: #f14747;
    }
  }
  .disabled-operate {
    background: #bfbfbf;
    color: #fff;
    padding: 6px 20px;
    border: none;
    font-size: 14px;
    border-radius: 2px;
    cursor: not-allowed;
    margin-left: 20px;
    width: 90px;
    display: inline-block;
    font-size: 12px;
    height: 32px;
    line-height: 20px;
    &.hover {
      background: #bfbfbf;
    }
  }
  strong {
    color: #f13232;
    font-weight: normal;
  }
}
.border-top {
  border-top: 1px solid #e0e0e0;
}
.border-bottom {
  border-bottom: 1px solid #e0e0e0;
}
.o-item {
  position: relative;
  padding: 16px 0 4px 88px;
  font-size: 12px;
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  &.o-item-detail {
    padding: 0 0 4px 88px;
  }
  // border: 1px solid #E0E0E0;
  &-label {
    position: absolute;
    top: 0;
    left: 0;
    width: 100px;
    height: 100%;
    padding-top: 16px;
    // text-align: center;
    border-right: 1px solid #e0e0e0;
    color: #666;
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;
  }
  &-info {
    padding-left: 20px;
    color: #333333;
  }
  .group {
    margin-bottom: 12px;
  }
  .promotion-item {
    margin-bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// module/order/src/components/sub/payInfo.vue